import React, {useEffect, useState} from "react";
import leftArrow from "../assets/icons/left-arrow.svg";
import MegaJackpotIcon from "../assets/images/mega-jackpot-full-icon.svg";
import {useNavigate} from "react-router-dom";
import MainButton from "../components/MainButton";
import Completionist from "../components/Completionist";
import BuyTicketIcon from "../assets/icons/buy-ticket-icon.svg";
import Countdown from "react-countdown"
import {Modal, Spin} from "antd";
import RegularGameIcon from "../assets/images/regular-game-icon.svg";
import StandardGameIcon from "../assets/images/standard-game-icon.svg";
import PremiumGameIcon from "../assets/images/premium-game-icon.svg";
import TonIcon from "../assets/icons/ton-icon.svg";
import DecrementIcon from "../assets/icons/decrement-icon.svg";
import IncrementIcon from "../assets/icons/increment-icon.svg";
import {AllTicketsCount} from "../constants/const";
import CompleteModal from "../components/CompleteModal";
import {useTonConnectUI} from "@tonconnect/ui-react";
import ProgressChartMain from "../components/ProgressChartMain";

function MegaJackpotPage() {
    const [timeStamp, setTimeStamp] = useState<any>();
    const [gameName, setGameName] = useState<any>();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [gameInfo, setGameInfo] = useState({name: "", icon: ""});
    const [inputValue, setInputValue] = useState(1);
    const [totalCount, setTotalCount] = useState(10);
    const [loading, setLoading] = useState<any>(false);
    const [isError, setIsError] = useState(false);
    const [infoModalOpen, setInfoModalOpen] = useState(false);
    const [tonConnectUI] = useTonConnectUI();
    const navigate = useNavigate();

    const [percent, setPercent] = useState(0);
    const [price, setPrice] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const [megaJackpotStart, setMegaJackpotStart] = useState(false);

    useEffect(() => {
        setPrice(13120)
        setTotalPrice(25000)
        setPercent(13120 / 25000)
    }, [])


    useEffect(() => {
        let newName = localStorage.getItem("gameName")
        setGameName(newName)
        switch (newName) {
            case "regular-game":
                setGameInfo({name: "Регулярная игра", icon: RegularGameIcon})
                break;
            case "standard-game":
                setGameInfo({name: "Стандартная игра", icon: StandardGameIcon})
                break;
            case "premium-game":
                setGameInfo({name: "Премиум игра", icon: PremiumGameIcon})
                break;
            default:
                console.log("warning")
        }

        setTimeStamp(1511412420)
    }, []);

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const handleOpenBuyMegaJackpotModal = () => {
        if (tonConnectUI.connected) {
            setIsModalOpen(true)
        } else {
            tonConnectUI.openModal()
                .then(() => {
                    const checkConnectionInterval = setInterval(() => {
                        if (tonConnectUI.connected === true) {
                            setIsModalOpen(true);
                            clearInterval(checkConnectionInterval);
                        }
                    }, 500);
                })
                .catch((error) => {
                    return (
                        <CompleteModal
                            infoModalOpen={infoModalOpen}
                            setInfoModalOpen={setInfoModalOpen}
                            errorTitle
                            errorContent
                            isError={isError}
                        />
                    )
                });

        }
    };

    const handleDecrement = () => {
        if (Number(inputValue) > 1) {
            let decrementValue: any = Number(inputValue) - 1;
            let totalPriceInUsdt = decrementValue * 25
            setInputValue(decrementValue);
            setTotalCount(totalPriceInUsdt)
        }
    };
    const handleIncrement = () => {
        if (Number(inputValue) < AllTicketsCount) {
            let incrementValue: any = Number(inputValue) + 1;
            let totalPriceInUsdt = incrementValue * 25
            setInputValue(incrementValue);
            setTotalCount(totalPriceInUsdt)
        }
    };

    const handleInputValue = (e: any) => {
        let inputCount: any = Number(e.target.value)
        if (inputCount <= AllTicketsCount && inputCount >= 0) {
            let totalPriceInUsdt = inputCount * 25
            setInputValue(inputCount)
            setTotalCount(totalPriceInUsdt)
        }
    };

    const handleBuyMegaJackpotTicket = () => {
        setIsModalOpen(false)
        setLoading(true)

        setTimeout(() => {
            setLoading(false)
        }, 3000)
        let status = true
        if (status) {
            setInfoModalOpen(true);
        } else {
            setIsError(true)
            setInfoModalOpen(true);
        }
    };

    return (
        <>
            {loading ? <Spin fullscreen={true} size="large"/> :
                <div className="jackpot-info-card">
                    <div className="jackpot-header">
                        <img
                            className="jackpot-header_left-arrow"
                            src={leftArrow}
                            alt="icon"
                            width={32}
                            height={32}
                            onClick={() => navigate('/games')}
                        />
                        <span>Мега Джекпот</span>
                    </div>

                    {megaJackpotStart ?
                        <div className="mega-jackpot-info-card">
                            <div className="mega-jackpot-info-card_title">
                                В ожидании запуска
                            </div>
                            <ProgressChartMain percent={percent} price={price} totalPrice={totalPrice}/>
                            <div className="mega-jackpot-info-card_content">
                                Как только баланс достигнет $25,000 соревнование начнётся. Следите за прогрессом на
                                шкале и
                                будьте готовы к большому выигрышу!
                            </div>

                        </div> :
                        <div className="mega-jackpot-start-card">
                            <div className="mega-jackpot-start-card_content">
                                <div className="mega-jackpot-start-card_content__title">
                                    Выигрыш
                                </div>
                                <div className="mega-jackpot-start-card_content__count">
                                    {"48,211"} TON
                                </div>
                                <div className="mega-jackpot-start-card_content__text">
                                    У вас есть шанс стать обладателем огромного приза, который изменит вашу жизнь
                                    навсегда.
                                </div>
                                <div className="mega-jackpot-start-card_content__btn">
                                    <MainButton
                                        icon={BuyTicketIcon}
                                        text={'Купить билет'}
                                        func={handleOpenBuyMegaJackpotModal}
                                    />
                                </div>
                            </div>
                        </div>
                    }


                    <Modal
                        title="Мега Джекпот"
                        open={isModalOpen}
                        onCancel={handleCancel}
                        footer={null}
                        rootClassName='buy-ticket-modal'
                    >
                        <div className="buy-ticket-modal-content">
                            <div className="buy-ticket-modal-content_price">
                                <img src={TonIcon} alt="icon" width={40} height={40}/>
                                <span>{10} TON</span>
                            </div>
                            <div className="datetime-container"
                                 style={{height: "auto", marginTop: "16px", marginBottom: '32px'}}>
                                <div className="buy-ticket-block">
                                    <div className="buy-ticket-block_header">
                                        <div className="buy-ticket-block_header__title">
                                            Количество билетов
                                        </div>
                                        <div className="buy-ticket-block_header__subtitle">
                                            Вы можете выбрать количество билетов с номерами, которые будут присвоены
                                            случайным образом.
                                        </div>
                                    </div>
                                    <div className="ticket-count-input">
                                        <img src={DecrementIcon} alt="icon" onClick={handleDecrement}/>
                                        <input
                                            type="text"
                                            className="ticket-count-input_count"
                                            value={inputValue}
                                            onChange={handleInputValue}
                                        />
                                        <img src={IncrementIcon} alt="icon" onClick={handleIncrement}/>
                                    </div>

                                    <div className="buy-ticket-block_btn">
                                        <MainButton
                                            icon={BuyTicketIcon}
                                            text={'Купить билет за'}
                                            price={totalCount}
                                            func={handleBuyMegaJackpotTicket}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>

                    </Modal>

                    <CompleteModal
                        infoModalOpen={infoModalOpen}
                        setInfoModalOpen={setInfoModalOpen}
                        isError={isError}
                    />
                </div>
            }
        </>
    )

}

export default MegaJackpotPage